export const removePrefix = (value, prefix) => value.startsWith(prefix) ? value.slice(prefix.length) : value;
//# sourceMappingURL=string-utils.js.map